module.exports = __webpack_public_path__ + "static/media/default.898a765c.less";